import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { CategoryType } from 'type';
import api from 'api';

interface initialStateType {
   categories: CategoryType[];
   isLoading: boolean;
   error: string;
}

const initialState: initialStateType = {
   categories: [] as CategoryType[],
   isLoading: false,
   error: ''
};

export const getCategories = createAsyncThunk('categories/getCategories', async (args, { rejectWithValue }) => {
   try {
      const { data } = await api.fetchCategories();
      return await data;
   } catch (error) {
      rejectWithValue(error);
   }
});

const categoriesSlice = createSlice({
   name: 'categories',
   initialState,
   reducers: {},
   extraReducers: {
      [`${getCategories.pending}`]: (state) => {
         state.isLoading = true;
      },
      [`${getCategories.fulfilled}`]: (state, action) => {
         state.isLoading = false;
         state.categories = action.payload || [];
      },
      [`${getCategories.rejected}`]: (state, action) => {
         state.isLoading = true;
         state.error = action.payload;
      }
   }
});

export const getCategoriesSelector = (state: RootState) => state.categories.categories;
export const getIsLoading = (state: RootState) => state.categories.isLoading;
export default categoriesSlice.reducer;
